module.exports = __webpack_public_path__ + "img/icon_map_ljpgfm_c.af66392f.png";